'use strict';

var DataExtractFilterGridDirective = function DataExtractFilterGridDirective($timeout, angularHelper, TreeGridAdapter, validationService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/data-extract-filter-grid.html'),
    controller: 'DataExtractFilterGridController',
    require: 'ngModel',
    scope: {
      filters: '='
    },
    link: function link($scope, elem, attr, ngModelCtrl) {
      $timeout(function () {
        var treeGridElem = elem.find('#apply-filter-tree-grid');
        $scope.treeGridAdapter = new TreeGridAdapter(treeGridElem);
        $scope.init();
        var triggerDigest = function triggerDigest() {
          angularHelper.triggerDigest($scope);
        };
        treeGridElem.on('rowSelect', triggerDigest);
        treeGridElem.on('rowUnselect', triggerDigest);
        treeGridElem.on('rowBeginEdit', function () {
          $scope.isEditing = true;
          triggerDigest();
        });
        treeGridElem.on('rowEndEdit', function () {
          $scope.isEditing = false;
          triggerDigest();
        });
        $scope.$watch('filters', function () {
          $scope.appliedFilters.push.apply($scope.appliedFilters, $scope.filters);
          $scope.init();
        });
        $scope.$watch('appliedFilters', function () {
          ngModelCtrl.$setViewValue($scope.appliedFilters);
        }, true);
        validationService.setTreeGrid($scope.treeGridAdapter);
      }, 0);
      $scope.$on('data-extract:levelChanged', $scope.levelChangedHandler);
      $scope.$on('data-extract:addAppliedFilter', $scope.addAppliedFilterHandler);
    }
  };
};
DataExtractFilterGridDirective.$inject = ['$timeout', 'AngularHelper', 'TreeGridAdapterFactory', 'DataExtractValidationService'];
module.exports = DataExtractFilterGridDirective;